// import { Pagination, PaginationItem, Stack, Typography } from '@mui/material';
// import React from 'react';
// import { HiOutlineArrowLeft, HiOutlineArrowRight } from 'react-icons/hi';
// // import { AppColors } from '../Utils/helper/AppColors';

// export default function CustomTablePagination({
//     count = 100, // Total number of items
//     page = 1, // Current page
//     rowsPerPage = 10, // Items per page
//     onChange, // Function to handle page change
// }) {
//     const NextButton = () => (
//         <Stack direction="row" alignItems="center" gap={1}>
//             <Typography variant="subtitle1" fontSize={12}>
//                 Next
//             </Typography>
//             <HiOutlineArrowRight />
//         </Stack>
//     );
//     const PrevButton = () => (
//         <Stack direction="row" alignItems="center" gap={1}>
//             <HiOutlineArrowLeft />
//             <Typography variant="subtitle1" fontSize={12}>
//                 Previous
//             </Typography>
//         </Stack>
//     );

//     // Calculate the total number of pages
//     const totalPages = Math.ceil(count / rowsPerPage);

//     return (
//         <Pagination
//             page={page}
//             count={totalPages}
//             onChange={onChange}
//             renderItem={(item) => <PaginationItem slots={{ previous: PrevButton, next: NextButton }} {...item} />}
//             shape="rounded"
//             sx={{ '& .MuiPagination-ul': { justifyContent: 'center', mt: 2 } }}
//         />
//     );
// }

import { Stack, Typography , TablePagination, Paper} from '@mui/material';
import React from 'react';
import { HiOutlineArrowLeft, HiOutlineArrowRight } from 'react-icons/hi';
import { AppColors } from '../Utils/helper/AppColors';
// import { AppColors } from '../Utils/helper/AppColors';

export default function CustomTablePagination({
    count = 0,     // its nothing but total user count (total User/campaigns)
    page = 1, 
    rowsPerPage = 10, 
    onChange, // Function to handle page change
}) {

    const handleChangePage = (event, newPage) => {
        onChange(newPage + 1, rowsPerPage); // Pass both page and current rowsPerPage
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        onChange(1, newRowsPerPage); // Reset to page 1 when rows per page changes
    };


    return (
    //     <Paper
    //     elevation={3} // Add a slight elevation for a card-like appearance
    //     sx={{
    //         borderRadius: '12px', // Add rounded corners
    //         padding: 1, // Add slight padding for aesthetics
    //         marginY: 1, // Add slight vertical margin for spacing
    //         display: 'flex',
    //         alignItems: 'center',
    //         justifyContent: 'space-between', // Ensure proper alignment
    //         backgroundColor: '#f9f9f9', // Optional: change background color
    //     }}
    // >    {/* </Paper> */}

        <TablePagination
            component="div"
            sx={theme => ({
                color: theme.palette.primary.midnight_balck, // Change text color for better visibility
                paddingY: 0, // Remove unnecessary vertical padding
                '& .MuiTablePagination-toolbar': {
                    minHeight: '36px', // Adjust toolbar height
                },
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-input, & .MuiTablePagination-displayedRows': {
                    fontSize: '14px', // Slightly increase font size for readability
                },
                '& .MuiTablePagination-actions button': {
                    color: theme.palette.primary.darker_primary, // Change button color for better visibility
                },
            })}
            count={count}
            page={page - 1} // Convert to 0-based index for TablePagination
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[10, 25, 50,100,500,1000,5000]}
        />
    );
}